module.exports={
    "analyzeDeal": "Analyze deal",
    "selectAreaInfoPopup": {
        "description": "You can add your own custom values using the + button below.",
        "maximumSelection": "You may need to deselect values as only 3 can be enabled at a time.",
        "help": "Help"
    },
    "saveDeal": "Save Deal",
    "editDeal": "Edit Deal",
    "save": "Save",
    "edit": "Edit"
}
